import React, { useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";

function SubscribeModal({ onClose }) {
  const [phone, setPhone] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone.trim()) return;

    setLoading(true);
    setStatus(null);
    try {
      const res = await fetch(`${API_BASE}/api/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: phone.trim() }),
      });
      const data = await res.json();
      if (res.ok) {
        setStatus({ type: "success", message: data.message });
        setPhone("");
      } else {
        setStatus({ type: "error", message: data.error || "שגיאה" });
      }
    } catch {
      setStatus({ type: "error", message: "שגיאת תקשורת" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <div className="modal-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
        </div>
        <h2>קבלת התראות SMS</h2>
        <p className="modal-desc">
          הכנס את מספר הטלפון שלך ותקבל הודעת SMS בכל פעם שמתפרסמת הודעה חדשה בקבוצה
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="tel"
            placeholder="050-1234567"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="modal-input"
            dir="ltr"
            autoFocus
          />
          <button type="submit" className="modal-submit" disabled={loading || !phone.trim()}>
            {loading ? "שולח..." : "הרשמה לקבלת התראות"}
          </button>
        </form>

        {status && (
          <div className={`modal-status ${status.type}`}>
            {status.message}
          </div>
        )}
      </div>
    </div>
  );
}

export default SubscribeModal;
